import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import StepIndicator from "../components/StepIndicator";
import { useApp } from "../context/AppContext";

const US_STATES = [
  "Alabama","Alaska","Arizona","Arkansas","California","Colorado","Connecticut",
  "Delaware","Florida","Georgia","Hawaii","Idaho","Illinois","Indiana","Iowa",
  "Kansas","Kentucky","Louisiana","Maine","Maryland","Massachusetts","Michigan",
  "Minnesota","Mississippi","Missouri","Montana","Nebraska","Nevada","New Hampshire",
  "New Jersey","New Mexico","New York","North Carolina","North Dakota","Ohio",
  "Oklahoma","Oregon","Pennsylvania","Rhode Island","South Carolina","South Dakota",
  "Tennessee","Texas","Utah","Vermont","Virginia","Washington","West Virginia",
  "Wisconsin","Wyoming",
];

const AGE_RANGES = ["18–24","25–34","35–44","45–54","55–64","65+"];

const HEAR_ABOUT = [
  "Social Media (Facebook / Instagram)",
  "Friend or Family Referral",
  "Google / Search Engine",
  "Email Newsletter",
  "Online Advertisement",
  "Other",
];

const QuizPage = () => {
  const navigate = useNavigate();
  const { updateUserData } = useApp();

  const [usState,   setUsState]   = useState("");
  const [ageRange,  setAgeRange]  = useState("");
  const [hearAbout, setHearAbout] = useState("");
  const [checked,   setChecked]   = useState(false);
  const [result,    setResult]    = useState(null); // null | "qualified"

  const isReady = usState && ageRange && hearAbout && checked;

  const handleCheck = () => {
    updateUserData({ usState, ageRange, hearAbout });
    setResult("qualified");
  };

  if (result === "qualified") {
    return (
      <div className="page-wrapper">
        <Navbar />
        <main className="form-main">
          <div className="card">
            <div style={{ textAlign: "center" }}>
              <div style={{ fontSize: 64, margin: "8px 0 16px" }}>🎉</div>
              <h2 className="card-title" style={{ color: "#10b981" }}>
                Congratulations! You Qualify!
              </h2>
              <p style={{ color: "#64748b", fontSize: 14, lineHeight: 1.7, margin: "16px 0 28px" }}>
                Based on your answers, you are eligible to claim the{" "}
                <strong style={{ color: "#1a56db" }}>$5,000 cash prize</strong>.
                Complete your registration in the next steps to receive your payment.
              </p>

              <div className="qualified-box">
                <div className="qual-row">
                  <span className="qual-label">State:</span>
                  <span className="qual-val">{usState}</span>
                </div>
                <div className="qual-row">
                  <span className="qual-label">Age Range:</span>
                  <span className="qual-val">{ageRange}</span>
                </div>
                <div className="qual-row">
                  <span className="qual-label">Status:</span>
                  <span className="qual-val" style={{ color: "#10b981", fontWeight: 700 }}>
                    ✓ ELIGIBLE
                  </span>
                </div>
              </div>

              <button
                className="btn btn-primary"
                style={{ marginTop: 24 }}
                onClick={() => navigate("/details")}
              >
                CONTINUE TO REGISTRATION →
              </button>
            </div>
          </div>
        </main>
        <footer className="page-footer">© 2026 WinBig LLC. All rights reserved.</footer>
      </div>
    );
  }

  return (
    <div className="page-wrapper">
      <Navbar />
      <main className="form-main">
        <div className="card">
          <h2 className="card-title">Eligibility Check</h2>
          <p className="card-subtitle">Step 1 of 3 — Quick qualifying questions</p>
          <StepIndicator current={1} total={3} />

          <div className="form-group">
            <label className="form-label">Which U.S. state do you live in?</label>
            <select
              className="form-select"
              value={usState}
              onChange={(e) => setUsState(e.target.value)}
            >
              <option value="">— Select your state —</option>
              {US_STATES.map((s) => (
                <option key={s} value={s}>{s}</option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label className="form-label">What is your age range?</label>
            <div className="radio-group">
              {AGE_RANGES.map((a) => (
                <label key={a} className={`radio-option ${ageRange === a ? "selected" : ""}`}>
                  <input
                    type="radio"
                    name="age"
                    value={a}
                    checked={ageRange === a}
                    onChange={() => setAgeRange(a)}
                  />
                  {a}
                </label>
              ))}
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">How did you hear about this giveaway?</label>
            <select
              className="form-select"
              value={hearAbout}
              onChange={(e) => setHearAbout(e.target.value)}
            >
              <option value="">— Select an option —</option>
              {HEAR_ABOUT.map((h) => (
                <option key={h} value={h}>{h}</option>
              ))}
            </select>
          </div>

          <label className="checkbox-label">
            <input
              type="checkbox"
              checked={checked}
              onChange={(e) => setChecked(e.target.checked)}
            />
            <span>
              I confirm I am a U.S. resident, 18 years or older, and agree to the{" "}
              <span style={{ color: "#1a56db", textDecoration: "underline", cursor: "pointer" }}>
                official giveaway rules
              </span>.
            </span>
          </label>

          <button
            className={`btn btn-primary ${isReady ? "" : "disabled"}`}
            onClick={handleCheck}
            disabled={!isReady}
            style={{ marginTop: 24 }}
          >
            CHECK MY ELIGIBILITY →
          </button>
        </div>
      </main>
      <footer className="page-footer">© 2026 WinBig LLC. All rights reserved.</footer>
    </div>
  );
};

export default QuizPage;
